export function joursAvantDate(dateEntree) {
    const dateCible = new Date(dateEntree);
    const dateActuelle = new Date();
    dateActuelle.setHours(0, 0, 0, 0);
    const difference = dateCible - dateActuelle;
    const jours = Math.ceil(difference / (1000 * 60 * 60 * 24));
    return jours - 1;
}
